import { observable, action, computed } from 'mobx'
import api from '../api'
import userStore from './userStore'
import errorStore from './errorStore'
import translationStore from './translationStore'
import config from '../utils/config'

class favoritesStore {
  @observable favoriteCategories = []
  @observable fetchedBrandsOnce = false
  @observable fetchedFavoritesOnce = false
  @observable favoriteBrands = []
  @observable brands = []
  @observable homeBrands = []
  @observable homeFavBrands = []
  @observable allBrands
  @observable isLoading = false
  @computed get inProgress() {
    return !this.fetchedBrandsOnce
  }

  constructor() {
    this.fetchBrands()
  }

  @action.bound fetchFavoriteCategories() {
    this.isLoading = true
    return userStore.currentUser && Promise.all([
      api.Favorites.getAll()
        .then(action(categories => {
          this.favoriteCategories = categories && categories.favoriteCategories
        })),
      this.fetchBrands()
    ]).then(action(results => {
      this.brands = results[1]
      this.favoriteBrands = results[1].filter(brand => {
        return this.favoriteCategories.some(category => brand.cashback_categories.find(otherCategory => ((otherCategory._id === category._id) || (otherCategory.parent === category._id))))
      })
    })).finally(action(() => {
      this.isLoading = false
      this.fetchedFavoritesOnce = true
    }))
  }

  @action.bound forgetFavorites() {
    this.fetchedFavoritesOnce = false
    this.favoriteCategories = []
    this.favoriteBrands = []
  }

  @action.bound fetchBrands() {
    this.isLoading = true
    return api.Brands.getAll()
      .then(action(brands => {
        this.brands = brands
        this.allBrands = brands;

        this.homeBrands = brands.filter(brand => {
          return [
            'jack-and-jones-de',
            'mister-spex-de',
            'foot-locker-de',
            'guess-de',
            'ravensburger-de',
            'nivea-de',
            'fressnapf-online-shop-de',
            'tefal-de',
            'orion-de',
            'eufylife-de',
            'playmobil-de',
            'christ-de',
            'shop-apotheke-de',
            'europcar-de',
            'rowenta-de',
            'tom-tailor-de',
            'samsung-shop-de'
          ].includes(brand.alias)
        })

        this.homeFavBrands = brands.filter(brand => {
          return [
            'reparaturhelden',
            'blume-ideal',
            'shop24direct-de',
            'mactrade-apple-store-de',
            'pkwteile-de',
            'just-fashion-now-de'
          ].includes(brand.alias)
        })

        return brands
      }))
      .finally(action(() => this.fetchedBrandsOnce = true))
  }

  @action.bound chooseFirstFavoriteCategories(mainCategories) {
    const categories = mainCategories.filter(category => category.possible)

    return api.Favorites.putFavoriteCategories(categories.map(category => category._id))
      .then(() => this.fetchFavoriteCategories())
  }

  @action.bound toggleFavoriteCategories(category) {
    if (!userStore.currentUser) {
      return
    }
    else {
      if (this.favoriteCategories.filter((favCat) => favCat._id === category._id).length > 0) {
        this.favoriteCategories = this.favoriteCategories.filter((favCat) => favCat._id !== category._id)
      }
      else {
        this.favoriteCategories.push(category)
      }
      api.Favorites.putFavoriteCategories(this.favoriteCategories.map(category => category._id))
        .then(() => this.fetchFavoriteCategories())
    }
  }
}

const favoritesStoreSingleton = new favoritesStore()

export default favoritesStoreSingleton



// WEBPACK FOOTER //
// ./src/stores/favoritesStore.js